import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic'

// FR values are translated from the PIM English list; confirm against Comestri FR output once mapped.
const gemstoneColourSprites = new Map([
  ['Black', 'black'],
  ['Noir', 'black'],
  ['Brown', 'brown'],
  ['Brun', 'brown'],
  ['Blue', 'blue'],
  ['Bleu', 'blue'],
  ['Dark Blue', 'dark-blue'],
  ['Bleu foncé', 'dark-blue'],
  ['Light Blue', 'light-blue'],
  ['Bleu clair', 'light-blue'],
  ['Green', 'green'],
  ['Vert', 'green'],
  ['Pink', 'pink'],
  ['Rose', 'pink'],
  ['Purple', 'purple'],
  ['Violet', 'purple'],
  ['Light Purple', 'light-purple'],
  ['Violet clair', 'light-purple'],
  ['Red', 'red'],
  ['Rouge', 'red'],
  ['White', 'white'],
  ['Blanc', 'white'],
  ['Teal', 'teal'],
  ['Sarcelle', 'teal'],
  ['Yellow', 'gemstone-yellow'],
  ['Jaune', 'gemstone-yellow'],
  ['Orange', 'orange'],
  ['Multi', 'multi-stone'],
])

export const getSpriteName = (option: ShopperProductsTypes.VariationAttribute): string => {
  if (option.attrName === 'PIMColourMetal') {
    switch (option.id) {
      case '15':
      case '27':
      case '517':
        return 'silver'
      case '11':
      case '26':
      case '263':
        return 'rose'
      case '18':
      case '28':
        return 'white'
      case '25':
      case '31':
      case '264':
      case '5':
      case '559':
        return 'yellow'
      case '204':
      case '214':
        return 'rose-white'
      case '20':
      case '118':
        return 'white-rose'
      case '23':
      case '29':
        return 'yellow-white'
      case '206':
      case '217':
        return 'white-yellow'
      case '14':
      case '171':
        return 'silver-yellow'
      case '1':
      case '202':
        return 'black'
      case '470':
        return 'red'
      case '461':
        return 'orange'
      case '3':
      case '445':
        return 'brown'
      case '6':
      case '145':
      case '548':
        return 'grey'
      case '12':
      case '146':
        return 'silver-rose'
      case '574':
        return 'silver-purple'
      case '579':
        return 'silver-brown'
      case '563':
        return 'silver-red'
      case '7':
      case '8':
      case '9':
      case '10':
      case '209':
      case '210':
      case '211':
        return 'platinum'
      case '16':
      case '147':
        return 'steel'
      case '176':
        return 'yellow-black'
      case '213':
      case '215':
        return 'white-yellow-rose'
      case '185':
      case '512':
        return 'steel-blue'
      case '184':
        return 'steel-black'
      case '493':
        return 'black-yellow'
      case '186':
      case '513':
        return 'steel-brown'
      case '180':
        return 'rose-blue'
      case '182':
        return 'rose-brown'
      case '188':
      case '199':
        return 'steel-rose'
      case '187':
      case '515':
        return 'steel-grey'
      case '173':
        return 'steel-green'
      case '543':
        return 'steel-yellow'
      case '24':
      case '30':
        return 'yellow-white-rose'
      case '191':
        return 'yellow-brown'
      case '190':
        return 'yellow-blue'
      case '452':
        return 'yellow-green'
      case '21':
        return 'yellow-rose'
      case '566':
        return 'yellow-red'
      case '567':
        return 'yellow-pink'
      case '561':
        return 'silver-green'
      case '560':
        return 'silver-blue'
      case '575':
        return 'silver-turquoise'
      case '571':
        return 'silver-black'
      default:
        // TODO: If Better Stack is formally established, use Sentry.logger if these are not captured by SSR logs
        console.warn(
          `[getSpriteName] Unmapped PIMColourMetal id "${option.id}" (value: "${option.value}") - falling back to 'grey'`,
        )
        return 'grey'
    }
  }
  if (option.attrName === 'PIMColourGold') {
    switch (option.id) {
      case '239':
      case '240':
      case '241':
      case '242':
      case '243':
        return 'rose'
      case '255':
      case '256':
      case '257':
      case '258':
      case '259':
        return 'silver'
      case '244':
      case '245':
      case '246':
      case '247':
      case '248':
        return 'white'
      case '249':
      case '250':
      case '251':
      case '252':
      case '253':
        return 'yellow'
      case '6':
      case '145':
        return 'grey'
      default:
        // TODO: If Better Stack is formally established, use Sentry.logger if these are not captured by SSR logs
        console.warn(
          `[getSpriteName] Unmapped PIMColourGold id "${option.id}" (value: "${option.value}") - falling back to 'grey'`,
        )
        return 'grey'
    }
  }
  if (option.attrName === 'PIMColourPWBRings') {
    switch (option.id) {
      case '531':
        return 'rose'
      case '532':
        return 'rose-white'
      case '535':
        return 'white'
      case '538':
        return 'white-yellow'
      case '536':
        return 'white-rose'
      case '539':
        return 'yellow'
      case '541':
        return 'yellow-white'
      case '534':
      case '537':
      case '542':
        return 'yellow-white-rose'
      case '6':
      case '145':
        return 'grey'
      default:
        // TODO: If Better Stack is formally established, use Sentry.logger if these are not captured by SSR logs
        console.warn(
          `[getSpriteName] Unmapped PIMColourPWBRings id "${option.id}" (value: "${option.value}") - falling back to 'grey'`,
        )
        return 'grey'
    }
  }
  if (option.attrName === 'c_metalColour' || option.attrName === 'metalColour') {
    switch (option.value) {
      case 'Sterling Silver':
      case 'Silver':
        return 'silver'
      case 'Rose':
        return 'rose'
      case 'White':
        return 'white'
      case 'Yellow':
      case 'Gold Tone':
        return 'yellow'
      case 'All Gold':
        return 'all-gold'
      case 'Rose & White':
        return 'rose-white'
      case 'White & Rose':
        return 'white-rose'
      case 'Yellow & White':
        return 'yellow-white'
      case 'White & Yellow':
        return 'white-yellow'
      case 'Silver & Yellow':
        return 'silver-yellow'
      case 'Black':
        return 'black'
      case 'Brown':
        return 'brown'
      case 'Grey':
        return 'grey'
      case 'Silver & Rose':
        return 'silver-rose'
      case 'Steel':
        return 'steel'
      case 'Yellow & Black':
        return 'yellow-black'
      case 'White, Yellow & Rose':
        return 'white-yellow-rose'
      case 'Steel & Blue':
        return 'steel-blue'
      case 'Steel & Black':
        return 'steel-black'
      case 'Black & Yellow':
        return 'black-yellow'
      case 'Steel & Brown':
        return 'steel-brown'
      case 'Rose & Blue':
        return 'rose-blue'
      case 'Steel & Rose':
        return 'steel-rose'
      case 'Steel & Grey':
        return 'steel-grey'
      case 'Yellow, White & Rose':
        return 'yellow-white-rose'
      case 'Yellow and Brown':
        return 'yellow-brown'
      case 'Yellow and Red':
        return 'yellow-red'
      case 'Yellow and Pink':
        return 'yellow-pink'
      case 'Silver, Rhodium and Green':
        return 'silver-green'
      case 'Silver, Rhodium and Turquoise':
        return 'silver-turquoise'
      case 'Silver, Rhodium and Black':
        return 'silver-black'
      default:
        if (option.value.includes('Platinum')) {
          return 'platinum'
        }
        // TODO: If Better Stack is formally established, use Sentry.logger if these are not captured by SSR logs
        console.warn(`[getSpriteName] Unmapped ${option.attrName} value "${option.value}" - falling back to 'grey'`)
        return 'grey'
    }
  }
  const isGemstoneColour = option.attrName === 'c_gemstoneColour' || option.attrName === 'gemstoneColour'
  const colourSprite = isGemstoneColour ? gemstoneColourSprites.get(option.value) : undefined
  if (colourSprite) {
    return colourSprite
  }
  // gemstoneColour still carries gemstone types until Comestri remaps it to PIM Gemstone Colour (WI 264458).
  if (isGemstoneColour || option.attrName === 'c_gemstone' || option.attrName === 'gemstone') {
    switch (option.value) {
      case 'Amethyst':
      case 'Améthyste':
        return 'amethyst'
      case 'Aquamarine':
      case 'Aigue-marine':
        return 'aquamarine'
      case 'Australian Opal':
        return 'australian-opal'
      case 'Blue Topaz':
      case 'Topaze Bleue':
      case 'Topaze bleue':
        return 'blue-topaz'
      case 'Citrine':
        return 'citrine'
      case 'Created Emerald':
        return 'created-emerald'
      case 'Created Ruby':
      case 'Rubis créé en laboratoire':
        return 'created-ruby'
      case 'Created Sapphire':
      case 'Saphir créé en laboratoire':
        return 'created-sapphire'
      case 'Created White Sapphire':
        return 'created-white-sapphire'
      case 'Cubic Zirconium':
      case 'Zircon cubique':
        return 'cubic-zirconium'
      case 'Diamond':
      case 'Diamond Set':
      case 'Diamant':
      case 'Diamant serti':
        return 'diamond'
      case 'Emerald':
      case 'Émeraude':
        return 'emerald'
      case 'Garnet':
      case 'Grenat':
        return 'garnet'
      case 'Garnet & White Sapphire':
        return 'garnet-white-sapphire'
      case 'Malachite':
        return 'malachite'
      case 'Moonstone':
        return 'moonstone'
      case 'Morganite':
        return 'morganite'
      case 'Mother of Pearl':
      case 'Nacre':
        return 'mother-of-pearl'
      case 'Onyx':
        return 'onyx'
      case 'Opal':
      case 'Opale':
        return 'opal'
      case 'Pearl':
      case 'Perle':
        return 'pearl'
      case 'Peridot':
      case 'Péridot':
        return 'peridot'
      case 'Pink Sapphire':
        return 'pink-sapphire'
      case 'Created Pink Sapphire':
        return 'created-pink-sapphire'
      case 'London Blue Topaz & White Sapphire':
        return 'london-blue-topaz-white-sapphire'
      case 'Ruby':
      case 'Rubis':
        return 'ruby'
      case 'Sapphire':
      case 'Saphir':
        return 'sapphire'
      case 'Sodalite':
        return 'sodalite'
      case 'Tanzanite':
        return 'tanzanite'
      case 'Tiger Eye':
        return 'tiger-eye'
      case 'Tourmaline':
        return 'tourmaline'
      case 'Quartz':
        return 'quartz'
      case 'Multi Gemstone':
        return 'multi-stone'
      default:
        // TODO: If Better Stack is formally established, use Sentry.logger if these are not captured by SSR logs
        console.warn(`[getSpriteName] Unmapped ${option.attrName} value "${option.value}" - falling back to 'grey'`)
        return 'grey'
    }
  }
  return 'grey'
}
